import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { Admin } from "./Admin";
import "./Referrals.css";

export const Referrals = () => {
    
    const [referralCodes, setReferralCodes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddModal, setShowAddModal] = useState(false);

    const getReferralCodes = async () => {
        setLoading(true);
        const res = await axios.get("/api/auth/getReferralCodes")
        if (res) {
            console.log(res.data);
            setReferralCodes(res.data);
        }
        setLoading(false);
    };
    const openAddModal = () => {
        setShowAddModal(true);
    }
    const hideAddModal = () => {
        setShowAddModal(false);
    }

    useEffect(() => {
        getReferralCodes();
    },[]);

    return (
        <div>
            <div className="user_slide">
                <Admin />
            </div>
            <div className="main_window">
                <div className="challenge-heading">
                    <h1>Referral Codes</h1>
                </div>
                {
                    loading
                    ?
                    <h2 style={{ color: "white", textAlign: "center", marginTop: "20px" }}>Loading...</h2>
                    :
                    <div className="inner_window">
                        <table className="table table-striped" style={{ marginTop: "20px" }}>
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Code</th>
                                    <th scope="col">Bonus</th>
                                    <th scope="col">Affiliate User</th>
                                    <th scope="col">Affiliate Bonus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    referralCodes.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.referralCode}</td>
                                                <td>{item.referralBonus}</td>
                                                <td>{item.affiliateUser?.username ?? "-"}</td>
                                                <td>{item.affiliateBonus ?? "-"}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    )
}

export default Referrals;